module.exports = __webpack_public_path__ + "img/ghost.d4eb4f61.png";